import "./index.scss";
import Error, { ErrorProps } from "./layouts/Error";
import NoResult from "./layouts/NoResult";
import SectionLoading from "@components/SectionLoading";
import { Status } from "@models/common";
import classNames from "classnames";

interface SectionProps {
  className?: string;
  status: Status;
  children: React.ReactNode;
  showNoResult?: boolean;
  reload?: Function;
  Loading?: React.ReactNode;
  errorProps?: ErrorProps;
  loadingText?: string;
  errorTip?: string;
  traceID?: string;
  BlankResult?: React.ReactNode;
  version?: "V2";
  hideLoading?: boolean;
  blankTip?: string;
  ErrorComponent?: React.ReactNode;
}

const Section = ({
  className,
  status,
  children,
  showNoResult = false,
  reload,
  Loading: LoadingComponent,
  errorProps,
  loadingText,
  errorTip,
  traceID,
  BlankResult,
  version,
  hideLoading = false,
  blankTip,
  ErrorComponent = null,
}: SectionProps) => {
  if (version === "V2" && status === "succeeded" && !showNoResult) {
    return <>{children}</>;
  }
  return (
    <div
      className={classNames(
        "Component-Section",
        status,
        className,
        status !== "succeeded" || showNoResult ? "center" : "",
      )}
    >
      {status === "loading" &&
        hideLoading === false &&
        (LoadingComponent ? LoadingComponent : <SectionLoading loadingText={loadingText}></SectionLoading>)}

      {status === "blank" &&
        (BlankResult ? BlankResult : <NoResult errorTip={errorTip} blankTip={blankTip}></NoResult>)}
      {status === "failed" &&
        (ErrorComponent ? (
          ErrorComponent
        ) : (
          <Error {...errorProps} reload={reload as () => void} traceID={traceID}></Error>
        ))}

      {status === "succeeded" && !showNoResult && children}
      {status === "succeeded" && showNoResult && <NoResult></NoResult>}
    </div>
  );
};

export default Section;
